module.exports = __webpack_public_path__ + "img/8_windAndRain_yr.849ad68f.png";